import { render } from "./ModalComponents.vue?vue&type=template&id=61326c1a"
import script from "./ModalComponents.vue?vue&type=script&lang=js"
export * from "./ModalComponents.vue?vue&type=script&lang=js"

import "./ModalComponents.vue?vue&type=style&index=0&id=61326c1a&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/Genesii/COLON/wonderful-colon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__